import {DateUtilities} from '../../shared/utilities/date-utilities.model';

export class Order {
	id_order: number;
	txt_chassis: string;
	txt_model: string;
	txt_plate: string;
	cod_typ_state: string;
	cod_veh_type: string;
	date_rec_ins: string;
	id_typ_purchase: string;
	date_transfer_expected: string;
	flag_reallocated?: string;
	val_priority: string;
	flag_priority_forced: boolean;
	txt_labels: string;

	constructor(model?: any) {
		if (model) {
			this.id_order = model.id_order;
			this.txt_chassis = model.txt_chassis;
			this.txt_model = model.txt_model;
			this.txt_plate = model.txt_plate;
			this.cod_typ_state = model.cod_typ_state;
			this.cod_veh_type = model.cod_veh_type;
			this.id_typ_purchase = model.id_typ_purchase;
			this.flag_reallocated = model.flag_reallocated;
			this.date_rec_ins = DateUtilities.getDateWithoutTimes(model.date_rec_ins);
			this.date_transfer_expected = DateUtilities.getDateWithoutTimes(model.date_transfer_expected);
			this.val_priority = model.val_priority;
			this.flag_priority_forced = model.flag_priority_forced;
			this.txt_labels = model.txt_labels;
		}
	}
}
